'use strict';

/**
 * @link https://github.com/World-Architects/WA3/issues/2506
 */
let waFilterBar = {
	postFilters: function () {
		document.getElementById('filter-form').submit();
	}
};
